import {Suspense, lazy} from 'react'
import {createRoot} from 'react-dom/client'
import {BrowserRouter} from 'react-router-dom'
import {Provider} from 'react-redux'
import {store} from './redux/store'
import {Spin} from "antd"
import {LoadingOutlined} from "@ant-design/icons"

import './assets/scss/core.scss'

const LazyApp = lazy(() => import('./App'))
const container = document.getElementById('root')
const root = createRoot(container)

root.render(
    <BrowserRouter
        future={{
            v7_relativeSplatPath: true,
            v7_startTransition: true,
        }}
    >
        <Provider store={store}>
            <Suspense
                fallback={
                    <div
                        className="position-fixed left-0 top-0 w-100 h-100 d-flex justify-content-center align-items-center flex-column">
                        <div className="width-50 height-50 position-relative">
                            <div
                                className="position-absolute width-50 height-50 border-4 border-secondary box-sizing-border border-radius-50"></div>
                            <Spin
                                spinning={true}
                                delay={1}
                                indicator={
                                    <LoadingOutlined
                                        className="text-primary"
                                        style={{
                                            fontSize: 50
                                        }}
                                        spin
                                    />
                                }
                                theme={{
                                    token: {
                                        colorPrimary: '#f00'
                                    }
                                }}
                            />
                        </div>
                    </div>
                }
            >
                <LazyApp
                    root={root}
                />
            </Suspense>
        </Provider>
    </BrowserRouter>
)
